export default "__VITE_PUBLIC_ASSET__1e48735f__"